<template>
  <div class="warpper">
    <div class="warp">
      <div class="typeList">
        <template>
          <div
            class="typeUl"
            :class="item.open ? '' : 'liListAct'"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="oneTitle">
              <div class="left">
                <img
                  v-if="!item.open"
                  @click="listOpen(1, index)"
                  src="../../../assets/xg/icon_01.png"
                  alt=""
                />
                <img
                  v-else
                  @click="listOpen(2, index)"
                  src="../../../assets/xg/icon_02.png"
                  alt=""
                />
                <span class="tit">{{ item.title }}</span>
              </div>
              <div class="right">
                <i class="el-icon-plus" @click="onTwoInput(index, item)"></i>
                <i class="el-icon-close" @click="ownInputDel(item)"></i>
              </div>
            </div>
            <div class="liList">
              <div
                class="typeLi"
                @click="changeTypeLi(index, ind)"
                :class="it.act ? 'active' : ''"
                v-for="(it, ind) in item.childList"
                :key="ind"
              >
                <div class="twoTitle">{{ it.title }}</div>
                <div class="twoDel">
                  <i
                    class="el-icon-close"
                    @click="twoInputLiDel(index, ind)"
                  ></i>
                </div>
              </div>
              <div class="typeLiInput" v-if="item.twoInputShow">
                <el-input
                  v-model="twoInput"
                  @blur="twoInputBlur($event, item)"
                  placeholder="二级分类名称"
                ></el-input>
                <div class="twoDel">
                  <i class="el-icon-close" @click="twoInputDel(index)"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="oneUlInput" v-if="ownInputShow">
          <el-input
            v-model="ownInput"
            @blur="ownInputBlur"
            placeholder="一级分类名称"
          ></el-input>
          <div class="oneDel">
            <i class="el-icon-close" @click="ownInputShow = false"></i>
          </div>
        </div>
        <div style="height: 100px"></div>
        <div class="oneButton">
          <el-button
            class="but"
            @click="onOwnInput"
            type="primary"
            icon="el-icon-plus"
            >一级分类</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title" v-if="twoContId">
        <span>{{ oweTitle }}-{{ twoTitle }}</span>
        <span>检查内容</span>
      </div>
      <div class="contList">
        <div class="li" v-for="(item, ind) in contList" :key="ind">
          <el-input v-model="item.name" placeholder="请输入检查内容"></el-input>
          <img
            src="../../../assets/xg/icon_03.png"
            @click="contDel(ind)"
            alt=""
          />
        </div>
      </div>
      <div class="button">
        <el-button
          class="but"
          @click="addCont"
          type="primary"
          icon="el-icon-plus"
          >添加检查内容</el-button
        >
      </div>
      <div style="height: 100px"></div>
      <div class="sumbit">
        <el-button class="but" @click="sumbit" type="primary">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      contList: [],
      ownInput: "",
      twoInput: "",
      ownInputShow: false,
      listSum: [],
      oweTitle: "",
      twoTitle: "",
      twoContId: "",
      oweIndex: 0,
      contIndex: 0,
    };
  },
  async mounted() {
    await this.onLoad();
    await this.getHeight();
  },
  methods: {
    // 保存检查内容
    sumbit() {
      if (this.contList.length == 0) {
        this.$message.warning("请添加检查内容");
        return;
      }
      let arr = [];
      arr = this.contList.filter((res) => {
        if (!res.name) {
          return res;
        }
      });
      if (arr.length > 0) {
        this.$message.warning("请输入检查内容");
        return;
      }
      if (this.twoContId) {
        let data = {
          title: this.twoTitle,
          id: this.twoContId,
          content: this.contList,
        };
        this.$Apis.patrolLeveladdUp(data).then((res) => {
          if (res.code == 200) {
            this.getIndex();
            this.onLoad();
            this.$message.success("保存成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.$message.warning("未获取到子类,请刷新后重试");
      }
    },
    async onLoad() {
      await this.$Apis.patrolLevelTotalList({ rank: 1 }).then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            res.data.forEach((item, ind) => {
              item.open = true;
              item.twoInputShow = false;
              item.childList = [];
            });
          }
          this.list = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
      await this.$Apis.patrolLevelTotalList({ rank: 2 }).then((res) => {
        if (res.code == 200) {
          this.list.forEach((item) => {
            res.data.forEach((it) => {
              if (item.id == it.parentId) {
                item.childList.push(it);
              }
            });
          });
          this.list.forEach((item) => {
            if (item.childList.length > 0) {
              item.open = true;
            } else {
              item.open = false;
            }
          });
          // 判断回到原位置
          if (this.contIndex < 1 && this.oweIndex < 1) {
            for (var a = 0; a <= this.list.length; a++) {
              if (this.list[a].childList.length > 0) {
                this.list[a].childList[0].act = true;
                this.oweTitle = this.list[a].title;
                this.twoTitle = this.list[a].childList[0].title;
                this.twoContId = this.list[a].childList[0].id;
                this.contList = this.list[a].childList[0].content
                  ? JSON.parse(this.list[a].childList[0].content)
                  : [];
                return;
              }
            }
          } else {
            this.list[this.oweIndex].childList[this.contIndex].act = true;
            this.oweTitle = this.list[this.oweIndex].title;
            this.twoTitle =
              this.list[this.oweIndex].childList[this.contIndex].title;
            this.twoContId =
              this.list[this.oweIndex].childList[this.contIndex].id;
            this.contList = this.list[this.oweIndex].childList[this.contIndex]
              .content
              ? JSON.parse(
                  this.list[this.oweIndex].childList[this.contIndex].content
                )
              : [];
          }
        }
      });
    },
    // 获取选中一级二级的索引值
    getIndex() {
      let list = JSON.parse(JSON.stringify(this.list));
      list.forEach((item, index) => {
        item.childList.forEach((it, ind) => {
          if (it.act) {
            this.oweIndex = index;
            this.contIndex = ind;
          }
        });
      });
    },
    getHeight() {
      let arrDom = document.querySelectorAll(".typeList .typeUl");
      if (arrDom && arrDom.length > 0) {
        arrDom.forEach((res) => {
          res.style.height = res.offsetHeight + "px";
        });
      }
    },
    // 点击切换二级分类
    changeTypeLi(cindex, cind) {
      let list = JSON.parse(JSON.stringify(this.list));
      list.forEach((res, index) => {
        if (res.childList && res.childList.length > 0) {
          res.childList.forEach((item, ind) => {
            item.act = false;
          });
        }
      });
      list[cindex].childList[cind].act = true;
      this.oweTitle = list[cindex].title;
      this.twoTitle = list[cindex].childList[cind].title;
      this.twoContId = list[cindex].childList[cind].id;
      this.contList = list[cindex].childList[cind].content
        ? JSON.parse(list[cindex].childList[cind].content)
        : [];
      this.list = list;
    },
    // 删除检查内容
    contDel(ind) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.contList.splice(ind, 1);
        // this.$Apis.patrolDel({ id }).then((res) => {
        //   if (res.code == 200) {
        //     this.onLoad();
        //     this.$message.success("删除成功");
        //   } else {
        //     this.$message.warning(res.msg);
        //   }
        // });
      });
    },
    // 添加检查内容
    addCont() {
      let obj = {
        name: "",
      };
      this.contList.push(obj);
    },
    // 二级分类删除
    twoInputLiDel(index, ind) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = this.list[index].childList[ind].id;
        this.$Apis.patrolLeveldel({ id }).then((res) => {
          if (res.code == 200) {
            let arrDom = document.querySelectorAll(".typeList .typeUl");
            arrDom[index].style.height = arrDom[index].offsetHeight - 40 + "px";
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    // 二级分类输入框删除
    twoInputDel(index) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.list[index].twoInputShow = false;
        if (this.list[index].childList.length == 0) {
          this.list[index].open = false;
        }
        let arrDom = document.querySelectorAll(".typeList .typeUl");
        arrDom[index].style.height = arrDom[index].offsetHeight - 40 + "px";
      });
    },
    // 二级分类提交
    twoInputBlur(e, item) {
      this.twoInput = e.target.value;
      if (this.twoInput) {
        let data = {
          title: this.twoInput,
          parentId: item.id,
        };
        this.$Apis.patrolLeveladdUp(data).then((res) => {
          if (res.code == 200) {
            this.getIndex();
            this.onLoad();
            this.twoInputShow = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    },
    // 二级分类输入框显示
    onTwoInput(index, item) {
      this.list[index].open = true;
      if (!this.list[index].twoInputShow) {
        this.twoInput = "";
        this.list[index].twoInputShow = true;
        let arrDom = document.querySelectorAll(".typeList .typeUl");
        arrDom[index].style.height = arrDom[index].offsetHeight + 40 + "px";
      } else {
        this.$message.warning("您还未输入内容！");
      }
    },
    // 一级分类提交
    ownInputBlur(e) {
      this.ownInput = e.target.value;
      if (this.ownInput) {
        let data = {
          title: this.ownInput,
        };
        this.$Apis.patrolLeveladdUp(data).then((res) => {
          if (res.code == 200) {
            this.getIndex()
            this.onLoad();
            this.ownInputShow = false;
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    },
    // 删除
    ownInputDel(item) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.patrolLeveldel({ id: item.id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    // 添加一级分类
    onOwnInput() {
      this.ownInput = "";
      this.ownInputShow = true;
    },
    // 左侧列表展开收缩
    listOpen(e, index) {
      if (this.list[index].childList.length > 0) {
        this.list[index].open = e == 1 ? true : false;
      } else {
        this.$message.warning("暂无子级分类");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warpper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .warp {
    width: 15%;
    border-right: 2px solid #f5f5f5;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    .typeList {
      .typeUl {
        height: 100%;
        transition: all 0.1s linear;
        position: relative;
        .oneTitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          color: #333;
          padding: 10px 0;
          padding-right: 5px;
          box-sizing: border-box;
          .left {
            display: flex;
            align-items: center;
            .tit {
              max-width: 170px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-left: 5px;
            }
            img {
              width: 16px;
              height: 16px;
              cursor: pointer;
            }
          }
          .right {
            display: flex;
            align-items: center;
            cursor: pointer;
            i {
              color: #409eff;
            }
          }
        }
        .typeLiInput {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 15%;
          padding-right: 5px;
          box-sizing: border-box;
          cursor: pointer;
          .el-input {
            max-width: 170px;
          }
          i {
            color: #409eff;
          }
        }
        .typeLi {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          padding-left: 15%;
          padding-right: 5px;
          box-sizing: border-box;
          cursor: pointer;
          transition: all 0.3s linear;
          .twoTitle {
            max-width: 170px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          i {
            color: #409eff;
          }
        }
        .active {
          color: #fff;
          background: #409eff;
          i {
            color: #fff;
          }
        }
      }
      .liListAct {
        height: 40px !important;
        overflow-y: hidden;
      }
      .oneUlInput {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
        padding: 10px 0;
        padding-right: 5px;
        box-sizing: border-box;
        .el-input {
          max-width: 203px;
        }
        i {
          color: #409eff;
          cursor: pointer;
        }
      }
      .oneButton {
        width: 100%;
        margin-top: 30px;
        position: absolute;
        padding: 10px;
        left: 0;
        bottom: 0;
        .but {
          width: 100%;
        }
      }
    }
  }
  .content {
    width: 83%;
    position: relative;
    .title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .contList {
      .li {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        img {
          width: 40px;
          height: 40px;
          margin-left: 30px;
          cursor: pointer;
        }
      }
    }
    .sumbit {
      position: absolute;
      left: 10px;
      bottom: 10px;
    }
  }
}
</style>